import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckCircle, faCircle, faDotCircle, faHeadset, faTimes } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';
function ModalMensaje(props) {
    useEffect(() => {
    }, []);
    return (
        <>
            {props.show ? <div className="w3-modal w3-show modal-error">
                <div className="w3-modal-content w3-animate-zoom w3-round-large" style={{width: '100%', maxWidth: 400}}>
                    <div className="w3-row">
                        <div className="w3-col w3-right" style={{ width: '50px' }}>
                            <IconButton aria-label="delete" onClick={props.hide}>
                                &nbsp;<FontAwesomeIcon icon={faTimes} color={'#3A3A3A'} />&nbsp;
                            </IconButton>
                        </div>
                        <div className="w3-rest w3-padding w3-center">
                            {/* <span>{props.edicion.label}</span> */}
                        </div>
                    </div>
                    <div className="w3-padding-large bs-bbox w3-center">
                        {/* <FontAwesomeIcon icon={faCheckCircle} size="3x" color={'#28A745'} /> */}
                        {props.mensajes ? props.mensajes.map((msg, index) => <h3 key={index}><FontAwesomeIcon icon={faCircle} color={'#DFDDDC'} /> {msg}</h3>) : null}
                        
                        <button className="w3-btn w3-theme w3-large w3-round-large" onClick={props.hide}><FontAwesomeIcon icon={faCheck} color="#fff" /> OK</button>
                        <br/><br/>
                    </div>
                </div>
            </div> : null}
        </>
    );
}
export default ModalMensaje;